import React from 'react';
import { PiRocketLaunch } from 'react-icons/pi';
import { LiaToolsSolid } from 'react-icons/lia';
import { CgPlayListCheck } from 'react-icons/cg';
import { BiCog } from 'react-icons/bi';

const ICON_MAP = {
	PiRocketLaunch: <PiRocketLaunch />,
	CgPlayListCheck: <CgPlayListCheck />,
	LiaToolsSolid: <LiaToolsSolid />,
	BiCog: <BiCog />
};

export default ICON_MAP;
